import { useState } from "react";
import LogoAdoraTeam from "./LogoAdoraTeam";
import { auth, salvarToken } from "../Api";

const GOLD = "#F9A826";
const BLUE = "#0f1729";
const API = process.env.REACT_APP_API_URL || "http://localhost:3000";

// ── Tela de redefinição de senha ──
function TelaRedefinirSenha({ onVoltar }) {
    const [passo, setPasso] = useState("email"); // "email" | "codigo" | "nova" | "ok"
    const [email, setEmail] = useState("");
    const [codigo, setCodigo] = useState("");
    const [novaSenha, setNovaSenha] = useState("");
    const [confirmar, setConfirmar] = useState("");
    const [verSenha, setVerSenha] = useState(false);
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState("");

    const enviarEmail = async () => {
        if (!email) return setErro("Digite seu e-mail.");
        setCarregando(true); setErro("");
        try {
            await fetch(`${API}/api/auth/esqueci-senha`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            }).then(r => r.json()).then(d => { if (d.erro) throw new Error(d.erro); });
            setPasso("codigo");
        } catch (e) {
            setErro(e.message || "Erro ao enviar e-mail.");
        } finally {
            setCarregando(false);
        }
    };

    const verificarCodigo = async () => {
        if (!codigo || codigo.length < 6) return setErro("Digite o código de 6 dígitos.");
        setCarregando(true); setErro("");
        try {
            await fetch(`${API}/api/auth/verificar-codigo`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, codigo }),
            }).then(r => r.json()).then(d => { if (d.erro) throw new Error(d.erro); });
            setPasso("nova");
        } catch (e) {
            setErro(e.message || "Código inválido ou expirado.");
        } finally {
            setCarregando(false);
        }
    };

    const redefinirSenha = async () => {
        if (!novaSenha || novaSenha.length < 6) return setErro("Senha deve ter pelo menos 6 caracteres.");
        if (novaSenha !== confirmar) return setErro("As senhas não coincidem.");
        setCarregando(true); setErro("");
        try {
            await fetch(`${API}/api/auth/redefinir-senha`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, codigo, nova_senha: novaSenha }),
            }).then(r => r.json()).then(d => { if (d.erro) throw new Error(d.erro); });
            setPasso("ok");
        } catch (e) {
            setErro(e.message || "Erro ao redefinir senha.");
        } finally {
            setCarregando(false);
        }
    };

    const inputStyle = {
        width: "100%", padding: "13px 16px", borderRadius: 12,
        border: "1.5px solid #2a3a5e", background: "#0f1729",
        color: "white", fontSize: 15, boxSizing: "border-box",
        transition: "border-color 0.2s", outline: "none",
    };

    return (
        <div style={{ minHeight: "100vh", background: BLUE, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "24px 20px", boxSizing: "border-box" }}>
            <style>{`.ri-input:focus { border-color: ${GOLD} !important; }`}</style>

            <div style={{ marginBottom: 28, textAlign: "center" }}>
                <LogoAdoraTeam size={56} glow={true} />
            </div>

            <div style={{ background: "#162040", borderRadius: 24, padding: 28, width: "100%", maxWidth: 400, boxSizing: "border-box", boxShadow: "0 8px 40px #0006" }}>

                {passo === "ok" ? (
                    <div style={{ textAlign: "center", padding: "20px 0" }}>
                        <div style={{ fontSize: 56, marginBottom: 16 }}>✅</div>
                        <div style={{ fontSize: 20, fontWeight: 800, color: "white", marginBottom: 8 }}>Senha redefinida!</div>
                        <div style={{ fontSize: 14, color: "#8899bb", marginBottom: 24 }}>Você já pode entrar com sua nova senha.</div>
                        <button onClick={onVoltar} style={{ width: "100%", padding: 14, borderRadius: 14, background: `linear-gradient(135deg, ${GOLD}, #FFD166)`, border: "none", color: BLUE, fontWeight: 800, fontSize: 15, cursor: "pointer" }}>
                            Ir para o login →
                        </button>
                    </div>
                ) : (
                    <>
                        <button onClick={onVoltar} style={{ background: "none", border: "none", color: "#8899bb", fontSize: 13, cursor: "pointer", marginBottom: 16, display: "flex", alignItems: "center", gap: 4, padding: 0 }}>
                            ← Voltar
                        </button>

                        {/* Indicador de passo */}
                        <div style={{ display: "flex", gap: 6, marginBottom: 24 }}>
                            {["email", "codigo", "nova"].map((p, i) => (
                                <div key={p} style={{ flex: 1, height: 4, borderRadius: 2, background: ["email", "codigo", "nova"].indexOf(passo) >= i ? GOLD : "#2a3a5e", transition: "background 0.3s" }} />
                            ))}
                        </div>

                        {passo === "email" && (
                            <>
                                <div style={{ fontSize: 20, fontWeight: 800, color: "white", marginBottom: 4 }}>Esqueci minha senha 🔑</div>
                                <div style={{ fontSize: 13, color: "#8899bb", marginBottom: 24 }}>Digite seu e-mail e enviaremos um código de verificação.</div>
                                <div style={{ marginBottom: 20 }}>
                                    <div style={{ fontSize: 12, fontWeight: 600, color: "#8899bb", marginBottom: 6 }}>E-MAIL</div>
                                    <input className="ri-input" type="email" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === "Enter" && enviarEmail()} placeholder="seu@email.com" style={inputStyle} />
                                </div>
                                {erro && <div style={{ background: "#f4433618", border: "1px solid #f4433644", borderRadius: 10, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: "#ff6b6b" }}>⚠️ {erro}</div>}
                                <button onClick={enviarEmail} disabled={carregando} style={{ width: "100%", padding: 15, borderRadius: 14, background: carregando ? "#2a3a5e" : `linear-gradient(135deg, ${GOLD}, #FFD166)`, border: "none", color: BLUE, fontWeight: 800, fontSize: 16, cursor: carregando ? "default" : "pointer" }}>
                                    {carregando ? "Enviando..." : "Enviar código →"}
                                </button>
                            </>
                        )}

                        {passo === "codigo" && (
                            <>
                                <div style={{ fontSize: 20, fontWeight: 800, color: "white", marginBottom: 4 }}>Verifique seu e-mail 📬</div>
                                <div style={{ fontSize: 13, color: "#8899bb", marginBottom: 24 }}>
                                    Enviamos um código de 6 dígitos para <span style={{ color: GOLD, fontWeight: 700 }}>{email}</span>
                                </div>
                                <div style={{ marginBottom: 20 }}>
                                    <div style={{ fontSize: 12, fontWeight: 600, color: "#8899bb", marginBottom: 6 }}>CÓDIGO</div>
                                    <input
                                        className="ri-input"
                                        type="text"
                                        value={codigo}
                                        onChange={e => setCodigo(e.target.value.replace(/\D/g, "").slice(0, 6))}
                                        onKeyDown={e => e.key === "Enter" && verificarCodigo()}
                                        placeholder="000000"
                                        maxLength={6}
                                        style={{ ...inputStyle, fontSize: 28, letterSpacing: 8, textAlign: "center", fontWeight: 800 }}
                                    />
                                </div>
                                {erro && <div style={{ background: "#f4433618", border: "1px solid #f4433644", borderRadius: 10, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: "#ff6b6b" }}>⚠️ {erro}</div>}
                                <button onClick={verificarCodigo} disabled={carregando} style={{ width: "100%", padding: 15, borderRadius: 14, background: carregando ? "#2a3a5e" : `linear-gradient(135deg, ${GOLD}, #FFD166)`, border: "none", color: BLUE, fontWeight: 800, fontSize: 16, cursor: carregando ? "default" : "pointer" }}>
                                    {carregando ? "Verificando..." : "Verificar código →"}
                                </button>
                                <button onClick={() => { setErro(""); enviarEmail(); }} style={{ width: "100%", padding: 12, borderRadius: 14, background: "none", border: "1px solid #2a3a5e", color: "#8899bb", fontSize: 13, cursor: "pointer", marginTop: 10 }}>
                                    Reenviar código
                                </button>
                            </>
                        )}

                        {passo === "nova" && (
                            <>
                                <div style={{ fontSize: 20, fontWeight: 800, color: "white", marginBottom: 4 }}>Nova senha 🔒</div>
                                <div style={{ fontSize: 13, color: "#8899bb", marginBottom: 24 }}>Escolha uma senha forte para sua conta.</div>
                                <div style={{ marginBottom: 16 }}>
                                    <div style={{ fontSize: 12, fontWeight: 600, color: "#8899bb", marginBottom: 6 }}>NOVA SENHA</div>
                                    <div style={{ position: "relative" }}>
                                        <input className="ri-input" type={verSenha ? "text" : "password"} value={novaSenha} onChange={e => setNovaSenha(e.target.value)} placeholder="Mínimo 6 caracteres" style={{ ...inputStyle, paddingRight: 48 }} />
                                        <button onClick={() => setVerSenha(p => !p)} style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#8899bb" }}>{verSenha ? "🙈" : "👁"}</button>
                                    </div>
                                </div>
                                <div style={{ marginBottom: 20 }}>
                                    <div style={{ fontSize: 12, fontWeight: 600, color: "#8899bb", marginBottom: 6 }}>CONFIRMAR SENHA</div>
                                    <input className="ri-input" type={verSenha ? "text" : "password"} value={confirmar} onChange={e => setConfirmar(e.target.value)} onKeyDown={e => e.key === "Enter" && redefinirSenha()} placeholder="Repita a senha" style={inputStyle} />
                                </div>
                                {/* Indicador de força */}
                                {novaSenha.length > 0 && (
                                    <div style={{ marginBottom: 16 }}>
                                        <div style={{ display: "flex", gap: 4 }}>
                                            {[1, 2, 3, 4].map(n => {
                                                const forca = Math.min(Math.floor(novaSenha.length / 3), 4);
                                                const cores = ["#f44336", "#ff9800", GOLD, "#4caf50"];
                                                return <div key={n} style={{ flex: 1, height: 3, borderRadius: 2, background: n <= forca ? cores[forca - 1] : "#2a3a5e", transition: "background 0.2s" }} />;
                                            })}
                                        </div>
                                        <div style={{ fontSize: 10, color: "#8899bb", marginTop: 4 }}>
                                            {novaSenha.length < 6 ? "Fraca" : novaSenha.length < 9 ? "Razoável" : novaSenha.length < 12 ? "Boa" : "Forte"}
                                        </div>
                                    </div>
                                )}
                                {confirmar && novaSenha !== confirmar && (
                                    <div style={{ fontSize: 12, color: "#ff6b6b", marginBottom: 12 }}>⚠️ As senhas não coincidem</div>
                                )}
                                {erro && <div style={{ background: "#f4433618", border: "1px solid #f4433644", borderRadius: 10, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: "#ff6b6b" }}>⚠️ {erro}</div>}
                                <button onClick={redefinirSenha} disabled={carregando} style={{ width: "100%", padding: 15, borderRadius: 14, background: carregando ? "#2a3a5e" : `linear-gradient(135deg, ${GOLD}, #FFD166)`, border: "none", color: BLUE, fontWeight: 800, fontSize: 16, cursor: carregando ? "default" : "pointer" }}>
                                    {carregando ? "Salvando..." : "Redefinir senha ✓"}
                                </button>
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

export default function Login({ onLogin, onCadastro, onVoltar }) {
    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const [erro, setErro] = useState("");
    const [carregando, setCarregando] = useState(false);
    const [verSenha, setVerSenha] = useState(false);
    const [telaAtual, setTelaAtual] = useState("login"); // "login" | "redefinir"

    if (telaAtual === "redefinir") {
        return <TelaRedefinirSenha onVoltar={() => setTelaAtual("login")} />;
    }

    const entrar = async () => {
        if (!email || !senha) return setErro("Preencha e-mail e senha.");
        setCarregando(true); setErro("");
        try {
            const res = await auth.login(email, senha);
            salvarToken(res.token);
            onLogin(res.usuario);
        } catch (e) {
            setErro(e.message || "E-mail ou senha incorretos.");
        } finally {
            setCarregando(false);
        }
    };

    return (
        <div style={{ minHeight: "100vh", background: BLUE, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "24px 20px", boxSizing: "border-box" }}>
            <style>{`
                @keyframes fadeUp { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
                .login-input:focus { border-color: ${GOLD} !important; outline: none; }
            `}</style>

            <div style={{ animation: "fadeUp 0.5s ease both", marginBottom: 32, textAlign: "center" }}>
                <LogoAdoraTeam size={72} glow={true} />
                <div style={{ marginTop: 12 }}>
                    <span style={{ fontSize: 28, fontWeight: 900, color: "white", letterSpacing: -1 }}>Adora</span>
                    <span style={{ fontSize: 28, fontWeight: 900, color: GOLD, letterSpacing: -1 }}>Team</span>
                </div>
                <div style={{ fontSize: 13, color: "#8899bb", marginTop: 4 }}>Sua equipe de louvor em um só lugar</div>
            </div>

            <div style={{ animation: "fadeUp 0.5s 0.1s ease both", background: "#162040", borderRadius: 24, padding: 28, width: "100%", maxWidth: 400, boxSizing: "border-box", boxShadow: "0 8px 40px #0006" }}>
                <div style={{ fontSize: 20, fontWeight: 800, color: "white", marginBottom: 4 }}>Bem-vindo de volta 👋</div>
                <div style={{ fontSize: 13, color: "#8899bb", marginBottom: 24 }}>Entre na sua conta para continuar</div>

                <div style={{ marginBottom: 16 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: "#8899bb", marginBottom: 6 }}>E-MAIL</div>
                    <input className="login-input" type="email" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === "Enter" && entrar()} placeholder="seu@email.com"
                           style={{ width: "100%", padding: "13px 16px", borderRadius: 12, border: "1.5px solid #2a3a5e", background: "#0f1729", color: "white", fontSize: 15, boxSizing: "border-box", transition: "border-color 0.2s" }} />
                </div>

                <div style={{ marginBottom: 8 }}>
                    <div style={{ fontSize: 12, fontWeight: 600, color: "#8899bb", marginBottom: 6 }}>SENHA</div>
                    <div style={{ position: "relative" }}>
                        <input className="login-input" type={verSenha ? "text" : "password"} value={senha} onChange={e => setSenha(e.target.value)} onKeyDown={e => e.key === "Enter" && entrar()} placeholder="••••••••"
                               style={{ width: "100%", padding: "13px 48px 13px 16px", borderRadius: 12, border: "1.5px solid #2a3a5e", background: "#0f1729", color: "white", fontSize: 15, boxSizing: "border-box", transition: "border-color 0.2s" }} />
                        <button onClick={() => setVerSenha(p => !p)} style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#8899bb" }}>
                            {verSenha ? "🙈" : "👁"}
                        </button>
                    </div>
                </div>

                {/* Esqueci senha — agora funcional */}
                <div style={{ textAlign: "right", marginBottom: 20 }}>
                    <button onClick={() => setTelaAtual("redefinir")} style={{ background: "none", border: "none", color: GOLD, fontSize: 12, cursor: "pointer", fontWeight: 600, padding: 0 }}>
                        Esqueci minha senha
                    </button>
                </div>

                {erro && <div style={{ background: "#f4433618", border: "1px solid #f4433644", borderRadius: 10, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: "#ff6b6b" }}>⚠️ {erro}</div>}

                <button onClick={entrar} disabled={carregando} style={{ width: "100%", padding: 15, borderRadius: 14, background: carregando ? "#2a3a5e" : `linear-gradient(135deg, ${GOLD}, #FFD166)`, border: "none", color: BLUE, fontWeight: 800, fontSize: 16, cursor: carregando ? "default" : "pointer", boxShadow: carregando ? "none" : `0 4px 20px ${GOLD}44`, transition: "all 0.2s" }}>
                    {carregando ? "Entrando..." : "Entrar →"}
                </button>

                <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "20px 0" }}>
                    <div style={{ flex: 1, height: 1, background: "#2a3a5e" }} />
                    <span style={{ color: "#8899bb", fontSize: 12 }}>ou</span>
                    <div style={{ flex: 1, height: 1, background: "#2a3a5e" }} />
                </div>

                <button onClick={onCadastro} style={{ width: "100%", padding: 15, borderRadius: 14, background: "none", border: "1.5px solid #2a3a5e", color: "white", fontWeight: 700, fontSize: 15, cursor: "pointer", transition: "border-color 0.2s" }}>
                    Criar conta gratuita 🎵
                </button>
            </div>

            <div style={{ marginTop: 24, fontSize: 11, color: "#4a5a7e", textAlign: "center" }}>
                AdoraTeam © 2025 · Todos os direitos reservados
            </div>
        </div>
    );
}